// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  rowId: __t.u64().primaryKey().name("row_id"),
  matchId: __t.string().name("match_id"),
  playerId: __t.string().name("player_id"),
  endpointUrl: __t.string().name("endpoint_url"),
  clientToken: __t.string().name("client_token"),
  registeredAt: __t.timestamp().name("registered_at"),
});
